import { P1, P2, P3, P4, P5, P6, S1, S2, S3, I1, I2, I3, I4, HotelSample } from '../../assests/ExportImageIcon'

// Matches the "Category Chips" / "Package Type" field set from the user's
// Travel Packages spec doc (Modules 1 & 2) — replaces the earlier
// screenshot-derived chip set (All Packages/Contiki/Honeymoon/Solo Travel/
// Visa & Passport), which didn't match the doc.
export const PACKAGE_TYPES = [
    { label: 'Family', img: P1 },
    { label: 'Honeymoon', img: P3 },
    { label: 'Solo', img: P4 },
    { label: 'Adventure', img: P2 },
    { label: 'Luxury', img: P5 },
    { label: 'Budget', img: P6 },
]

export const DESTINATION_TYPES = ['Domestic', 'International']
export const DURATION_BUCKETS = ['1-3 Days', '4-6 Days', '7+ Days']
export const INCLUSION_OPTIONS = ['Flights', 'Meals', 'Guided Tours', 'Airport Transfers']
export const HOTEL_RATING_OPTIONS = [5, 4, 3]

export const durationBucketFor = (nights) => {
    if (nights <= 3) return '1-3 Days'
    if (nights <= 6) return '4-6 Days'
    return '7+ Days'
}

// No backend for Holidays yet — this whole list is static mock data. Spans
// both categories and Domestic/International so every filter in the sidebar
// has at least one real match to show, instead of always returning empty.
export const HOLIDAY_PACKAGES = [
    {
        id: 1,
        image: S1,
        badge: 'Popular',
        packageType: 'Family',
        destinationType: 'International',
        tags: ['Beach', 'Family with Kids', 'Visa Free'],
        title: 'Amazing Phuket',
        nights: 3,
        days: 4,
        cityLine: 'Phuket (3)',
        country: 'Thailand',
        inclusions: ['Flights', 'Meals', 'Airport Transfers'],
        highlights: ['Phuket', 'Big Buddha', 'Patong Beach', 'Wat Chalong', 'Phi Phi Island', 'Maya Bay', 'Airport Pickup & Drop'],
        discountLabel: 'Upto 10% Off',
        price: 12390,
        oldPrice: 13767,
        rating: 4.5,
        reviewsCount: 128,
        hotelRating: 4,
        createdAt: '2026-09-10',
        gallery: [S1, P1, P2, I1],
        exclusions: ['Visa Fees', 'Personal Expenses', 'Tips & Gratuities', 'Travel Insurance'],
        hotelDetails: { name: 'Andaman Beach Suites', location: 'Patong Beach, Phuket', roomType: 'Deluxe Sea View Room', amenities: ['Pool', 'Free WiFi', 'Breakfast Included', 'Airport Shuttle'] },
        activities: {
            included: ['Phi Phi Island Speedboat Tour', 'Big Buddha & Wat Chalong Temple Visit'],
            optional: [{ name: 'Phuket FantaSea Show', price: 2200 }, { name: 'Scuba Diving Experience', price: 4500 }],
        },
        cancellationPolicy: 'Free cancellation up to 7 days before departure. 50% refund for cancellations 3-7 days before departure. No refund within 72 hours of departure.',
        itinerary: [
            { day: 1, title: 'Arrival in Phuket', description: 'Airport pickup and transfer to hotel. Evening free to explore Patong Beach.' },
            { day: 2, title: 'Phi Phi Island Tour', description: 'Full-day speedboat tour to Phi Phi Island, Maya Bay and Monkey Beach with lunch.' },
            { day: 3, title: 'City & Temple Tour', description: 'Visit Big Buddha, Wat Chalong Temple and local viewpoints.' },
            { day: 4, title: 'Departure', description: 'Free time for shopping, then airport transfer for departure.' },
        ],
    },
    {
        id: 2,
        image: S2,
        badge: 'Popular',
        packageType: 'Family',
        destinationType: 'International',
        tags: ['City Breaks', 'Family with Kids', 'Visa Free'],
        title: 'Simply Thailand',
        nights: 4,
        days: 5,
        cityLine: 'Pattaya (2) → Bangkok (2)',
        country: 'Thailand',
        inclusions: ['Flights', 'Meals', 'Guided Tours', 'Airport Transfers'],
        highlights: ['Coral Island', 'Chao Phraya River Cruise', 'Golden Buddha', 'Marble Buddha', 'Bangkok City', 'Airport Pickup & Drop'],
        discountLabel: 'Upto 10% Off',
        price: 15754,
        oldPrice: 17504,
        rating: 4.3,
        reviewsCount: 96,
        hotelRating: 4,
        createdAt: '2026-09-05',
        gallery: [S2, P3, I2, I3],
        exclusions: ['Visa Fees', 'Personal Expenses', 'Tips & Gratuities', 'Travel Insurance'],
        hotelDetails: { name: 'Pattaya Bayview Hotel', location: 'Central Pattaya', roomType: 'Superior Room', amenities: ['Pool', 'Free WiFi', 'Breakfast Included'] },
        activities: {
            included: ['Coral Island Speedboat Trip', 'Chao Phraya River Dinner Cruise', 'Bangkok City Tour'],
            optional: [{ name: 'Alcazar Cabaret Show', price: 1500 }, { name: 'Nong Nooch Village Tour', price: 1800 }],
        },
        cancellationPolicy: 'Free cancellation up to 7 days before departure. 50% refund for cancellations 3-7 days before departure. No refund within 72 hours of departure.',
        itinerary: [
            { day: 1, title: 'Arrival in Pattaya', description: 'Airport pickup and transfer to hotel. Evening at leisure.' },
            { day: 2, title: 'Coral Island Trip', description: 'Speedboat excursion to Coral Island with water activities and lunch.' },
            { day: 3, title: 'Transfer to Bangkok', description: 'Drive to Bangkok, evening Chao Phraya river dinner cruise.' },
            { day: 4, title: 'Bangkok City Tour', description: 'Visit Golden Buddha, Marble Buddha and local markets.' },
            { day: 5, title: 'Departure', description: 'Free time, then airport transfer for departure.' },
        ],
    },
    {
        id: 3,
        image: S3,
        badge: 'Featured',
        packageType: 'Adventure',
        destinationType: 'International',
        tags: ['Beach', 'Adventure', 'Visa Free'],
        title: 'Wonders of Thailand',
        nights: 4,
        days: 5,
        cityLine: 'Krabi (2) → Phuket (2)',
        country: 'Thailand',
        inclusions: ['Flights', 'Meals', 'Guided Tours'],
        highlights: ['Ao Nang Beach', 'Railay Beach', 'Phi Phi Island', 'Big Buddha', 'Airport Pickup & Drop'],
        discountLabel: 'Upto 10% Off',
        price: 18990,
        oldPrice: 21200,
        rating: 4.6,
        reviewsCount: 74,
        hotelRating: 3,
        createdAt: '2026-08-20',
        gallery: [S3, P2, I4, S1],
        exclusions: ['Visa Fees', 'Personal Expenses', 'Tips & Gratuities', 'Travel Insurance'],
        hotelDetails: { name: 'Krabi Cliff Resort', location: 'Ao Nang, Krabi', roomType: 'Garden View Room', amenities: ['Pool', 'Free WiFi', 'Breakfast Included'] },
        activities: {
            included: ['Ao Nang & Railay Beach Tour', 'Phi Phi Island Day Trip'],
            optional: [{ name: 'Rock Climbing at Railay', price: 3200 }, { name: 'Sunset Kayaking', price: 1600 }],
        },
        cancellationPolicy: 'Free cancellation up to 7 days before departure. 50% refund for cancellations 3-7 days before departure. No refund within 72 hours of departure.',
        itinerary: [
            { day: 1, title: 'Arrival in Krabi', description: 'Airport pickup and transfer to hotel in Ao Nang.' },
            { day: 2, title: 'Railay Beach Adventure', description: 'Longtail boat to Railay Beach, optional rock climbing.' },
            { day: 3, title: 'Transfer to Phuket', description: 'Drive to Phuket, evening free at Patong Beach.' },
            { day: 4, title: 'Phi Phi Island Tour', description: 'Full-day boat trip to Phi Phi Island and Maya Bay.' },
            { day: 5, title: 'Departure', description: 'Free time, then airport transfer for departure.' },
        ],
    },
    {
        id: 4,
        image: HotelSample,
        badge: 'Featured',
        packageType: 'Honeymoon',
        destinationType: 'International',
        tags: ['Honeymoon', 'City Breaks', 'Visa Free'],
        title: 'Romantic Chiang Mai',
        nights: 5,
        days: 6,
        cityLine: 'Chiang Mai (3) → Bangkok (2)',
        country: 'Thailand',
        inclusions: ['Meals', 'Guided Tours', 'Airport Transfers'],
        highlights: ['Doi Suthep', 'Night Safari', 'Old City Temples', 'Bangkok City', 'Airport Pickup & Drop'],
        discountLabel: 'Upto 8% Off',
        price: 22450,
        oldPrice: 24390,
        rating: 4.8,
        reviewsCount: 61,
        hotelRating: 5,
        createdAt: '2026-09-18',
        gallery: [HotelSample, P3, I1, I2],
        exclusions: ['Visa Fees', 'Personal Expenses', 'Tips & Gratuities', 'Travel Insurance'],
        hotelDetails: { name: 'Chiang Mai Riverside Resort', location: 'Old City, Chiang Mai', roomType: 'Honeymoon Suite', amenities: ['Pool', 'Free WiFi', 'Spa', 'Breakfast Included'] },
        activities: {
            included: ['Doi Suthep Temple Visit', 'Chiang Mai Night Safari'],
            optional: [{ name: 'Elephant Sanctuary Visit', price: 2800 }, { name: 'Thai Cooking Class', price: 1900 }],
        },
        cancellationPolicy: 'Free cancellation up to 10 days before departure. 50% refund for cancellations 5-10 days before departure. No refund within 5 days of departure.',
        itinerary: [
            { day: 1, title: 'Arrival in Chiang Mai', description: 'Airport pickup and transfer to hotel. Romantic welcome dinner.' },
            { day: 2, title: 'Doi Suthep & Old City', description: 'Visit Doi Suthep Temple and explore Old City temples.' },
            { day: 3, title: 'Night Safari', description: 'Free day at leisure, evening Chiang Mai Night Safari.' },
            { day: 4, title: 'Transfer to Bangkok', description: 'Flight to Bangkok, evening at leisure.' },
            { day: 5, title: 'Bangkok City Tour', description: 'Explore Bangkok City highlights and local markets.' },
            { day: 6, title: 'Departure', description: 'Free time, then airport transfer for departure.' },
        ],
    },
    {
        id: 5,
        image: P4,
        badge: null,
        packageType: 'Solo',
        destinationType: 'Domestic',
        tags: ['Solo', 'Budget', 'Beach'],
        title: 'Goa Solo Explorer',
        nights: 2,
        days: 3,
        cityLine: 'North Goa (2)',
        country: 'India',
        inclusions: ['Meals', 'Airport Transfers'],
        highlights: ['Baga Beach', 'Fort Aguada', 'Anjuna Flea Market', 'Airport Pickup & Drop'],
        discountLabel: 'Upto 12% Off',
        price: 6499,
        oldPrice: 7499,
        rating: 4.1,
        reviewsCount: 40,
        hotelRating: 3,
        createdAt: '2026-09-20',
        gallery: [P4, I3, I4, P6],
        exclusions: ['Personal Expenses', 'Tips & Gratuities', 'Travel Insurance', 'Adventure Sports'],
        hotelDetails: { name: 'Baga Beach Hostel', location: 'North Goa', roomType: 'Shared/Private Room', amenities: ['Free WiFi', 'Breakfast Included', 'Common Lounge'] },
        activities: {
            included: ['Baga & Anjuna Beach Walk', 'Fort Aguada Visit'],
            optional: [{ name: 'Water Sports Package', price: 1500 }, { name: 'Sunset Cruise', price: 900 }],
        },
        cancellationPolicy: 'Free cancellation up to 5 days before departure. 50% refund for cancellations 2-5 days before departure. No refund within 48 hours of departure.',
        itinerary: [
            { day: 1, title: 'Arrival in Goa', description: 'Airport pickup and transfer to hostel. Evening at Baga Beach.' },
            { day: 2, title: 'North Goa Exploration', description: 'Visit Fort Aguada, Anjuna Flea Market and Vagator Beach.' },
            { day: 3, title: 'Departure', description: 'Free time for beach and shopping, then airport transfer.' },
        ],
    },
    {
        id: 6,
        image: P5,
        badge: 'Featured',
        packageType: 'Luxury',
        destinationType: 'Domestic',
        tags: ['Luxury', 'Honeymoon', 'Backwaters'],
        title: 'Kerala Luxury Backwaters',
        nights: 4,
        days: 5,
        cityLine: 'Kochi (1) → Alleppey (2) → Munnar (1)',
        country: 'India',
        inclusions: ['Flights', 'Meals', 'Guided Tours', 'Airport Transfers'],
        highlights: ['Houseboat Stay', 'Tea Gardens', 'Fort Kochi', 'Spice Plantation', 'Airport Pickup & Drop'],
        discountLabel: 'Upto 10% Off',
        price: 28990,
        oldPrice: 32200,
        rating: 4.7,
        reviewsCount: 52,
        hotelRating: 5,
        createdAt: '2026-08-28',
        gallery: [P5, P1, I1, I3],
        exclusions: ['Visa Fees', 'Personal Expenses', 'Tips & Gratuities', 'Travel Insurance'],
        hotelDetails: { name: 'Alleppey Backwater Houseboat & Munnar Resort', location: 'Alleppey & Munnar, Kerala', roomType: 'Deluxe Houseboat Cabin / Mountain View Room', amenities: ['Pool', 'Free WiFi', 'Spa', 'All Meals Included'] },
        activities: {
            included: ['Alleppey Houseboat Cruise', 'Munnar Tea Garden Tour', 'Fort Kochi Walking Tour'],
            optional: [{ name: 'Spice Plantation Trek', price: 1200 }, { name: 'Ayurvedic Spa Session', price: 2500 }],
        },
        cancellationPolicy: 'Free cancellation up to 10 days before departure. 50% refund for cancellations 5-10 days before departure. No refund within 5 days of departure.',
        itinerary: [
            { day: 1, title: 'Arrival in Kochi', description: 'Airport pickup, Fort Kochi walking tour and local sightseeing.' },
            { day: 2, title: 'Alleppey Houseboat', description: 'Transfer to Alleppey, overnight stay on a private houseboat cruising the backwaters.' },
            { day: 3, title: 'Transfer to Munnar', description: 'Drive to Munnar through scenic tea gardens and spice plantations.' },
            { day: 4, title: 'Munnar Sightseeing', description: 'Visit tea gardens, Eravikulam National Park and local viewpoints.' },
            { day: 5, title: 'Departure', description: 'Free time, then transfer to Kochi airport for departure.' },
        ],
    },
]
